import { get, patch, post, getArrayBuffer } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  getItemsList: ({ commit }, { params } = {}) => {
    return get('/buildings', {
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  },

  retrieveBuildingsOfBuildingComplex: (_, idBuildingComplex) =>
    get(`/buildings-of-building-complex/${idBuildingComplex}`),

  retrieveBuilding: (_, building) => get(`/buildings/${building}`),

  retrieveKeysafeHouses: (_, idBuildingComplex) =>
    get(`/keysafe-houses/${idBuildingComplex}`),

  store: (_, building) => post('/buildings', building),

  update: (_, building) => patch(`/buildings/${building.id}`, building),

  getStatuses(_, params) {
    return get(`/filters/buildings/statuses`, params);
  },

  getBuildingComplexes(_, params) {
    return get(`/filters/buildings/building-complexes`, params);
  },

  getBuildingsExport(_, params) {
    return getArrayBuffer(`/buildings-export`, params);
  }
};
